export class LocalStorageService {
  public getItem<Type extends string | number> (key: string, defaulValue: Type): Type {
    const storedValue = localStorage.getItem(key);
    if (storedValue) {
      if (typeof defaulValue === 'string')
        return storedValue as Type;
      else if (typeof defaulValue === 'number')
        return Number.parseInt(storedValue) as Type;
    }
    return defaulValue;
  }

  public setItem<Type extends string | number>(key: string, value: Type) {
    if (typeof value === 'string')
      localStorage.setItem(key, value);
    else if (typeof value === 'number')
      localStorage.setItem(key, value.toString());
  }
}
